'use client';

import { cn } from '@utils';
import { tv } from 'tailwind-variants';

export interface HorizontalRuleProps extends React.ComponentPropsWithoutRef<'hr'> {
	variant?: 'large' | 'medium' | 'small' | 'auto';
}

const horizontalRule = tv({
	base: 'bg-neutral-lighter border-none',
	variants: {
		variant: {
			large: 'my-[31px] h-[2px]',
			medium: 'my-[23px] h-[2px]',
			small: 'mt-[16px] mb-[15px] h-[1px]',
			auto: 'mt-[16px] mb-[15px] h-[1px] md:my-[23px] md:h-[2px] lg:my-[31px] lg:h-[2px]',
		},
	},
	defaultVariants: {
		variant: 'auto',
	},
});

export function HorizontalRule({ className, variant, ...props }: HorizontalRuleProps) {
	return <hr className={cn(horizontalRule({ variant }), className)} {...props} />;
}
